import { EnumTipoDeRelacionamento } from '@/constants/EnumsBeneficiario'
import EnumTipoComponents from '@/components/TemplateSolicitacao/EnumTipoComponents'

const mapSectionListByContrato = (contratos, lista) => {
  const novaLista = []

  if (!Array.isArray(lista)) {
    return novaLista
  }

  contratos.forEach((contrato) => {
    const dadosLista = lista.find(
      (item) => contrato.numeroContrato === item.numeroContrato
    )

    const ocorrencias = formataOcorrencias((dadosLista || {}).ocorrencias)
    const newItem = {
      plano: contrato.descricaoContrato,
      tipoRelacionamento:
        EnumTipoDeRelacionamento[contrato.tipoDeRelacionamento],
      numeroContrato: contrato.numeroContrato,
      data: ocorrencias
    }

    novaLista.push(newItem)
  })

  // Sem ligação a contrato
  const dadosLista = lista.find(
    (item) => item.numeroContrato === null
  )

  if (dadosLista) {
    const ocorrencias = formataOcorrencias(dadosLista.ocorrencias)
    const newItem = {
      plano: 'Não atribuídos',
      tipoRelacionamento: '',
      numeroContrato: 'n/a',
      data: ocorrencias
    }

    novaLista.push(newItem)
  }

  return novaLista
}

const formataOcorrencias = (ocorrescias) => {
  if (!Array.isArray(ocorrescias)) {
    return []
  }

  return ocorrescias.map((ocorrescia) => {
    let situacao = {}
    if (ocorrescia.numeroGuiaReembolso || (ocorrescia.guia && ocorrescia.guia.idAutorizacao)) {
      situacao = {
        descricao: ocorrescia.situacao.descricao,
        cor: ocorrescia.situacao.cor
      }
    } else {
      situacao = {
        descricao: ocorrescia.status_label,
        cor: ocorrescia.status_cor
      }
    }
    return {
      ...ocorrescia,
      situacao: situacao
    }
  })
}

const formatPayloadSolicitacao = (template, idTipoOcorrencia, stepsData) => {
  let formularios = []
  let idSolicitacaoTemplateTipo = null
  let chaveUnica = null
  let numeroContrato = null
  let idConfigClienteAssunto = template.idConfigClienteAssunto
  let identificacao = null

  template.steps.forEach((step, index) => {
    let idForm = step.formulario ? step.formulario.idForm : null
    switch (step.tipo) {
      case EnumTipoComponents.grupoFamiliar:
        if (!stepsData[index].bypass) {
          chaveUnica = stepsData[index].beneficiario.chaveUnica
          numeroContrato = stepsData[index].beneficiario.numeroContrato
        }
        break
      case EnumTipoComponents.tipoSolicitacao:
        idConfigClienteAssunto = stepsData[index].assunto.idConfigClienteAssunto
        idSolicitacaoTemplateTipo = stepsData[index].assunto.idSolicitacaoTemplateTipo
        // Formulário padrão

        // formulário especifico do assunto
        if (stepsData[index].assunto.formulario) {
          idForm = stepsData[index].assunto.formulario.idForm
        }
        formularios.push({
          idStepConfig: step.idSolicitacaoTemplateStep,
          idForm: idForm,
          formData: stepsData[index].formData
        })
        break
      case EnumTipoComponents.formulario:
        formularios.push({
          idStepConfig: step.idSolicitacaoTemplateStep,
          idForm: idForm,
          formData: stepsData[index].formData
        })
        break
      case EnumTipoComponents.identificacao:
        if (!stepsData[index].bypass) {
          identificacao = {
            idStepConfig: step.idSolicitacaoTemplateStep,
            idForm: idForm,
            formData: stepsData[index].formData[0]
          }
        }
        break
    }
  })

  const payload = {
    formularios: formularios,
    idSolicitacaoTemplateTipo: idSolicitacaoTemplateTipo,
    chaveUnica: chaveUnica,
    numeroContrato: numeroContrato,
    idTemplateSolicitacao: template.idTemplateSolicitacao,
    idConfigClienteAssunto: idConfigClienteAssunto,
    idTipoOcorrencia,
    identificacao
  }
  return payload
}

export { mapSectionListByContrato, formatPayloadSolicitacao, formataOcorrencias }
